
import * as ActionTypes from '../../Constants/actionTypes';

const initialState = {
    message: '',
    isLoading: false,
    error: null
};

const alertReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_ALERT_REQUEST:
            return { ...state, isLoading: true, error: null };
        case ActionTypes.FETCH_ALERT_SUCCESS:
            return { ...state, message: action.payload.message, isLoading: false };
        case ActionTypes.FETCH_ALERT_FAILURE:
            return { ...state, isLoading: false, error: action.error };
        default:
            return state;
    }
};

export default alertReducer;
